"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTopics = exports.EventTypes = exports.CrudEventTypes = void 0;
// Please use `EventTypes` instead of `CrudEventTypes`
var CrudEventTypes;
(function (CrudEventTypes) {
    CrudEventTypes["CREATED"] = "created";
    CrudEventTypes["UPDATED"] = "updated";
})(CrudEventTypes || (exports.CrudEventTypes = CrudEventTypes = {}));
var EventTypes;
(function (EventTypes) {
    EventTypes["CREATED"] = "created";
    EventTypes["UPDATED"] = "updated";
    EventTypes["FAILED"] = "failed";
    EventTypes["DELETED"] = "deleted";
})(EventTypes || (exports.EventTypes = EventTypes = {}));
var EventTopics;
(function (EventTopics) {
    EventTopics["WP_CONFIG"] = "wp_config";
    EventTopics["WP_TRANSACTION"] = "wp_transaction";
    EventTopics["PAYMENT"] = "payment";
    EventTopics["PRODUCT"] = "product";
    EventTopics["PAYMENT_QUEUE"] = "paymentQueue";
    EventTopics["INVENTORY"] = "inventory";
    EventTopics["CUSTOMER"] = "customer";
    EventTopics["EMPLOYEE"] = "employee";
    EventTopics["WEBHOOK"] = "webhook";
    EventTopics["CATEGORY"] = "category";
    EventTopics["DISCOUNT"] = "discount";
    EventTopics["EXTERNAL_SOURCE"] = "externalSource";
})(EventTopics || (exports.EventTopics = EventTopics = {}));
//# sourceMappingURL=enums.js.map